import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegisterDataIntegrationStepControls } from 'src/features/Signup/hooks/useRegisterDataIntegrationStepControls';
import { CampaignMapping } from 'src/features/Signup/components/templates/DataIntegrationFlow/steps/CampaignMapping';
import {
  getStepIndex,
  getNextStepPath,
  getPrevStepPath,
} from 'src/features/Signup/utils/dataIntegrationSteps';

const nextPath = getNextStepPath('campaign-match');
const prevPath = getPrevStepPath('campaign-match');

export const CampaignMappingStepRoute: React.FC = () => {
  const navigate = useNavigate();

  useRegisterDataIntegrationStepControls({
    title: 'Campaign Match',
    subtitle: 'Compare campaign presence across each connected platform',
    currentStep: getStepIndex('campaign-match'),
    onNext: nextPath ? () => navigate(nextPath) : undefined,
    onBack: prevPath ? () => navigate(prevPath) : undefined,
    isBackDisabled: false,
    isNextDisabled: false,
  });

  return <CampaignMapping />;
};
